import { render, staticRenderFns } from "./FormatCategory.vue?vue&type=template&id=727773ce&scoped=true"
import script from "./FormatCategory.vue?vue&type=script&lang=js"
export * from "./FormatCategory.vue?vue&type=script&lang=js"
import style0 from "./FormatCategory.vue?vue&type=style&index=0&id=727773ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727773ce",
  null
  
)

export default component.exports